function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
// Read-only, bounded sync evidence shared by the browser module and full node.
// No wallet/options/peer dump is exposed, and no background polling is started.
var FRESH_MS = 120000;
var CACHE_MS = 2000;
var READ_TIMEOUT_MS = 1000;
var unknown = function unknown() {
  return Object.freeze({
    current: null,
    target: null,
    state: 'unknown'
  });
};
function height(value) {
  if (typeof value === 'bigint') {
    return value >= 0n && value <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(value) : null;
  }
  if (typeof value === 'string' && /^\d{1,16}$/.test(value)) value = Number(value);
  return Number.isSafeInteger(value) && value >= 0 ? value : null;
}
function createSyncStatus(app) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return Date.now();
  };
  var target = null;
  var targetAt = null;
  var cached = unknown();
  var cachedAt = -Infinity;
  var inFlight = null;
  var generation = 0;
  if (app && app.connection && typeof app.connection.on === 'function') {
    app.connection.on('on-blockchain-received', function (payload) {
      var next = height(payload && payload.target_block_id);
      if (next === null || next === 0) return;
      target = next;
      targetAt = now();
      cachedAt = -Infinity;
    });
    var invalidate = function invalidate() {
      var clearTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      generation++;
      if (clearTarget) target = null;
      targetAt = null;
      cached = unknown();
      cachedAt = -Infinity;
    };
    app.connection.on('new-chain-detected', function () {
      return invalidate();
    });
    // This event includes downstream browser peers too, not just our sync
    // source. Expire peer freshness but retain the known height: a recent
    // canonical tip can still demonstrate that this target has been reached.
    app.connection.on('peer_disconnect', function () {
      return invalidate(false);
    });
  }
  var sample = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var blockchain, current, timestamp, time, fresh, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            blockchain = app && app.blockchain;
            if (!(!blockchain || typeof blockchain.getLatestBlockId !== 'function')) {
              _context.n = 1;
              break;
            }
            return _context.a(2, unknown());
          case 1:
            _t = height;
            _context.n = 2;
            return blockchain.getLatestBlockId();
          case 2:
            current = _t(_context.v);
            if (!(current === null)) {
              _context.n = 3;
              break;
            }
            return _context.a(2, unknown());
          case 3:
            // A recent canonical block keeps an already known target fresh once chunk
            // syncing ends. Do not invent a peer target before one has been observed.
            timestamp = null;
            if (!(typeof blockchain.getLastBlockTimestamp === 'function')) {
              _context.n = 5;
              break;
            }
            _t2 = height;
            _context.n = 4;
            return blockchain.getLastBlockTimestamp();
          case 4:
            timestamp = _t2(_context.v);
          case 5:
            time = now();
            if (target !== null && current >= target && timestamp !== null && timestamp <= time && time - timestamp <= FRESH_MS) {
              target = current;
              targetAt = time;
            }
            fresh = targetAt !== null && time >= targetAt && time - targetAt <= FRESH_MS;
            return _context.a(2, Object.freeze({
              current: current,
              target: fresh ? target : null,
              state: !fresh ? 'unknown' : current < target ? 'catching-up' : 'current'
            }));
        }
      }, _callee);
    }));
    return function sample() {
      return _ref.apply(this, arguments);
    };
  }();
  return Object.freeze({
    read: function read() {
      if (inFlight) return inFlight;
      if (now() - cachedAt < CACHE_MS) return Promise.resolve(cached);
      var requestGeneration = generation;
      var timer;
      var timedOut = false;
      var operation = Promise.resolve().then(sample)["catch"](unknown);
      var timeout = new Promise(function (resolve) {
        timer = setTimeout(function () {
          timedOut = true;
          resolve(unknown());
        }, READ_TIMEOUT_MS);
      });
      inFlight = Promise.race([operation, timeout]).then(function (value) {
        clearTimeout(timer);
        cached = requestGeneration === generation ? value : unknown();
        cachedAt = now();
        if (!timedOut) inFlight = null;
        return cached;
      });
      // A stalled WASM operation must not accumulate another read on each poll.
      operation["finally"](function () {
        if (timedOut) inFlight = null;
      });
      return inFlight;
    }
  });
}
module.exports = {
  createSyncStatus: createSyncStatus
};